import queryString from "query-string"
import getHistory from "./getHistory"
import parseSearchQuery from "./parseSearchQuery"

const history = getHistory()

const _cleanObject = (obj) => {
    const newObject = {}

    for (let propName in obj) {
        if (!obj.hasOwnProperty(propName) || !obj[propName]) {
            continue
        }

        newObject[propName] = obj[propName]
    }

    return newObject
}

export default (query, push = false, clean = true) => {
    const parsed = parseSearchQuery()
    const changed = Object.assign({}, parsed, query)
    const cleaned = clean ? _cleanObject(changed) : changed

    if (push) {
        return history.push({
            search: queryString.stringify(cleaned)
        })
    }

    history.replace({
        search: queryString.stringify(cleaned)
    })
}
